// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"c6473e86e26e2f76","606":"7e8a979e17380f8c","818":"3737c4d077beeaca"}[chunkId] + ".js";
};